(function () {
  if (window.__pinnedScrollLoaded) {
    return;
  }
  window.__pinnedScrollLoaded = true;

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  var SELECTOR = '[data-pin-section]';
  var TEXT_SELECTOR = '[data-pin-text]';

  var SNAP_DURATION_MS = 1200;

  var DEBUG = true;

  var TEXT_RISE_PX = 46;
  var TEXT_STAGGER = 0.22;

  var TRANSITION_SCROLL_RATIO = 1;

  function injectStyles() {
    if (document.getElementById('pinned-scroll-styles')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'pinned-scroll-styles';
    style.textContent =
      'html{overflow-anchor:none;}' +
      '.pinned-scroll-container{position:relative;z-index:0;isolation:isolate;overflow-anchor:none;}' +
      '.pinned-scroll-stage{position:sticky;top:0;height:100vh;overflow:hidden;overflow-anchor:none;}' +
      '.pinned-scroll-item{position:absolute;top:0;left:0;width:100%;overflow-anchor:none;' +
      'will-change:transform;transition:none;backface-visibility:hidden;}' +
      '[data-pin-text]{will-change:transform,opacity;transition:none;}' +
      '.pinned-scroll-fade{opacity:0;transition:opacity 0.6s ease;will-change:opacity;}' +
      '.pinned-scroll-fade.is-visible{opacity:1;}';

    document.head.appendChild(style);
  }

  function initFadeOnly(sections) {
    sections.forEach(function (section, index) {
      section.setAttribute('data-pin-index', String(index));
      section.classList.add('pinned-scroll-fade');
    });

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (section) {
        section.classList.add('is-visible');
      });

      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function clamp01(value) {
    return value < 0 ? 0 : value > 1 ? 1 : value;
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function getHeaderOffset() {
    var header = document.querySelector('.header-wrapper');
    return header ? Math.max(Math.round(header.getBoundingClientRect().bottom), 0) : 0;
  }

  function getBottomBarOffset() {
    if (window.innerWidth > 1023) {
      return 0;
    }

    var bar = document.querySelector('.bottom-bar-items');
    return bar ? Math.max(window.innerHeight - bar.getBoundingClientRect().top, 0) : 0;
  }

  function initPinned(sections) {
    var container = document.createElement('div');
    container.className = 'pinned-scroll-container';

    var stage = document.createElement('div');
    stage.className = 'pinned-scroll-stage';
    container.appendChild(stage);

    var firstSection = sections[0];
    firstSection.parentNode.insertBefore(container, firstSection);

    var textEls = sections.map(function (section, index) {
      section.setAttribute('data-pin-index', String(index));
      section.classList.add('pinned-scroll-item');
      section.style.zIndex = String(index);
      stage.appendChild(section);
      return Array.prototype.slice.call(section.querySelectorAll(TEXT_SELECTOR));
    });

    var count = sections.length;
    var visibleHeight = window.innerHeight;

    var range = { top: 0, bottom: 0 };

    var currentProgress = 0;
    var settledIndex = 0;
    var isActive = false;

    var animFrom = 0;
    var animTo = 0;
    var animDuration = SNAP_DURATION_MS;
    var animStartTime = null;
    var isBusy = false;
    var lastOffset = new Array(count).fill(null);

    var naturalHeights = new Array(count).fill(0);
    var lastStageHeight = -1;
    var headerOffsetPx = 0;
    var bottomBarOffsetPx = 0;

    var segmentHeights = new Array(count).fill(0);
    var segmentStarts = new Array(count).fill(0);
    var transitionSpan = 0;

    var SCROLL_END_DELAY_MS = 120;
    var scrollEndTimer = null;
    var lastScrollY = null;
    var scrollDirection = 0;

    var RESIZE_IGNORE_THRESHOLD_PX = 100;
    var lastInnerHeight = window.innerHeight;

    function clearScrollEndTimer() {
      if (scrollEndTimer !== null) {
        window.clearTimeout(scrollEndTimer);
        scrollEndTimer = null;
      }
    }

    function scheduleScrollEndSnap() {
      clearScrollEndTimer();

      scrollEndTimer = window.setTimeout(function () {
        scrollEndTimer = null;

        if (!isActive || isBusy) {
          return;
        }

        var target;

        if (scrollDirection > 0) {
          target = Math.min(count - 1, Math.ceil(currentProgress - 0.001));
        } else if (scrollDirection < 0) {
          target = Math.max(0, Math.floor(currentProgress + 0.001));
        } else {
          target = Math.round(currentProgress);
        }

        if (Math.abs(target - currentProgress) > 0.01) {
          startAnim(target, Math.min(SNAP_DURATION_MS, 300));
        }
      }, SCROLL_END_DELAY_MS);
    }

    function measureHeights() {
      var changed = false;

      sections.forEach(function (section, index) {
        var h = section.offsetHeight;

        if (h > 0 && h !== naturalHeights[index]) {
          naturalHeights[index] = h;
          changed = true;
        }
      });

      if (changed) {
        relayout();
        updateRange();
      }
    }

    function updateStageHeight(progress, force) {
      var low = Math.floor(Math.min(Math.max(progress, 0), count - 1));
      var high = Math.min(count - 1, low + 1);

      var liveLow = sections[low] ? sections[low].offsetHeight : 0;
      var liveHigh = sections[high] ? sections[high].offsetHeight : 0;
      var height = Math.max(liveLow || naturalHeights[low] || 0, liveHigh || naturalHeights[high] || 0, 1);

      if (force || height !== lastStageHeight) {
        lastStageHeight = height;
        stage.style.height = height + 'px';
      }
    }

    function computeSegments() {
      var start = 0;
      var minSegment = visibleHeight * TRANSITION_SCROLL_RATIO;

      for (var i = 0; i < count - 1; i++) {
        segmentHeights[i] = minSegment;
        segmentStarts[i] = start;
        start += segmentHeights[i];
      }

      transitionSpan = start;

      segmentHeights[count - 1] = Math.max(minSegment, naturalHeights[count - 1] || 0);
      segmentStarts[count - 1] = start;
    }

    function relayout() {
      computeSegments();
      container.style.height = transitionSpan + segmentHeights[count - 1] + 'px';
      updateStageHeight(currentProgress, true);
    }

    function applySizing() {
      headerOffsetPx = getHeaderOffset();
      bottomBarOffsetPx = getBottomBarOffset();
      visibleHeight = Math.max(window.innerHeight - headerOffsetPx - bottomBarOffsetPx, 1);
      stage.style.top = headerOffsetPx + 'px';

      sections.forEach(function (section) {
        if (section.classList.contains("section-sugoi-feature-showcase")) {
          let topPadding = section.getAttribute("data-desktop-top-padding");
          let bottomPadding = section.getAttribute("data-desktop-bottom-padding");
          if (window.innerWidth < 768) {
            topPadding = section.getAttribute("data-mobile-top-padding");
            bottomPadding = section.getAttribute("data-mobile-bottom-padding");
          }

          topPadding = Number(topPadding);
          bottomPadding = Number(bottomPadding);
          section.style.paddingTop = headerOffsetPx + topPadding + "px";
          section.style.paddingBottom = bottomPadding + "px";
          section.style.height = visibleHeight + headerOffsetPx + bottomPadding + 'px';
        } else {
          section.style.height = visibleHeight + 'px';
        }
      });

      relayout();
    }

    function progressFromOffset(offset) {
      if (offset <= 0) {
        return 0;
      }

      for (var i = 0; i < count - 1; i++) {
        var segEnd = segmentStarts[i] + segmentHeights[i];

        if (offset < segEnd || i === count - 2) {
          var local = segmentHeights[i] > 0 ? (offset - segmentStarts[i]) / segmentHeights[i] : 1;
          return i + clamp01(local);
        }
      }

      return count - 1;
    }

    function updateRange() {
      var rect = container.getBoundingClientRect();
      var top = rect.top + window.pageYOffset;
      range.top = top;
      range.bottom = top + transitionSpan;
    }

    function offsetFromProgress(progress) {
      var low = Math.floor(Math.min(Math.max(progress, 0), count - 1));

      if (low >= count - 1) {
        return segmentStarts[count - 1];
      }

      var local = progress - low;
      return segmentStarts[low] + local * segmentHeights[low];
    }

    function setScrollY(y) {
      window.scrollTo({ top: y, left: 0, behavior: 'instant' });
    }

    function renderText(index, localProgress) {
      var els = textEls[index];

      if (!els.length) {
        return;
      }

      var staggered = clamp01((localProgress - TEXT_STAGGER) / (1 - TEXT_STAGGER));
      var eased = easeOutCubic(staggered);
      var offsetPx = (1 - eased) * TEXT_RISE_PX;

      els.forEach(function (el) {
        el.style.transform = 'translateY(' + offsetPx + 'px)';
        el.style.opacity = String(eased);
      });
    }

    function render(progress) {
      updateStageHeight(progress, false);

      sections.forEach(function (section, index) {
        var offset = index - progress;
        offset = offset < 0 ? 0 : offset > 1 ? 1 : offset;

        if (lastOffset[index] === offset) {
          return;
        }

        lastOffset[index] = offset;
        section.style.transform = 'translateY(' + offset * 100 + '%)';
        renderText(index, 1 - offset);
      });
    }

    function startAnim(to, duration) {
      clearScrollEndTimer();
      animFrom = currentProgress;
      animTo = to;
      animDuration = duration;
      animStartTime = null;
      isBusy = true;
    }

    function loop(timestamp) {
      if (isBusy) {
        if (animStartTime === null) {
          animStartTime = timestamp;
        }

        var t = animDuration > 0 ? clamp01((timestamp - animStartTime) / animDuration) : 1;
        currentProgress = animFrom + (animTo - animFrom) * easeInOutCubic(t);

        if (t >= 1) {
          currentProgress = animTo;
          settledIndex = Math.round(animTo);
          isBusy = false;
        }
      }

      if (isBusy) {
        setScrollY(range.top + offsetFromProgress(currentProgress));
      }

      render(currentProgress);
      requestAnimationFrame(loop);
    }

    function advance(direction) {
      var nextIndex = settledIndex + direction;

      if (nextIndex < 0 || nextIndex > count - 1) {
        isActive = false;
        clearScrollEndTimer();
        return false;
      }

      startAnim(nextIndex, SNAP_DURATION_MS);
      return true;
    }

    function onWheel(event) {
      if (!isActive || isBusy) {
        return;
      }

      if (advance(event.deltaY > 0 ? 1 : -1)) {
        event.preventDefault();
      }
    }

    var touchStartY = null;

    var touchStartWasActive = false;

    var TOUCH_THRESHOLD_FORWARD_PX = 20;
    var TOUCH_THRESHOLD_BACKWARD_PX = 20;
    var TOUCH_THRESHOLD_BACKWARD_SWIPER_PX = 120;

    var touchStartedOnSwiper = false;

    function onTouchStart(event) {
      touchStartY = event.touches.length ? event.touches[0].clientY : null;
      touchStartWasActive = isActive;
      touchStartedOnSwiper = !!(event.target && event.target.closest && event.target.closest('.swiper'));
      clearScrollEndTimer();
    }

    function onTouchMove(event) {
      if (!isActive) {
        return;
      }

      if (touchStartedOnSwiper) {
        return;
      }

      if (touchStartY !== null && event.touches.length) {
        var liveDelta = touchStartY - event.touches[0].clientY;
        var atLast = settledIndex >= count - 1;
        var atFirst = settledIndex <= 0;

        if ((liveDelta > 0 && atLast) || (liveDelta < 0 && atFirst)) {
          return;
        }
      }

      event.preventDefault();
    }

    function onTouchEnd(event) {
      if (!isActive || touchStartY === null || isBusy) {
        touchStartY = null;
        return;
      }

      var endY = event.changedTouches.length ? event.changedTouches[0].clientY : touchStartY;
      var delta = touchStartY - endY;
      touchStartY = null;

      var isBackward = delta < 0;
      var threshold = isBackward
        ? (touchStartedOnSwiper ? TOUCH_THRESHOLD_BACKWARD_SWIPER_PX : TOUCH_THRESHOLD_BACKWARD_PX)
        : TOUCH_THRESHOLD_FORWARD_PX;

      if (Math.abs(delta) < threshold) {
        return;
      }

      advance(delta > 0 ? 1 : -1);
    }

    function syncHeaderOffset() {
      var measured = getHeaderOffset();
      var measuredBottomBar = getBottomBarOffset();

      if (measured === headerOffsetPx && measuredBottomBar === bottomBarOffsetPx) {
        return;
      }

      applySizing();
      updateRange();
    }

    function onScroll() {
      if (isBusy) {
        return;
      }

      syncHeaderOffset();

      var y = window.scrollY;
      var withinRange = y > range.top - 2 && y < range.bottom + 2;

      if (lastScrollY !== null) {
        if (y > lastScrollY + 0.5) {
          scrollDirection = 1;
        } else if (y < lastScrollY - 0.5) {
          scrollDirection = -1;
        }
      }
      lastScrollY = y;

      if (withinRange && !isActive) {
        var nearest = progressFromOffset(y - range.top);

        isActive = true;
        currentProgress = nearest;
        settledIndex = Math.round(nearest);
        render(currentProgress);
        scheduleScrollEndSnap();
      } else if (withinRange && isActive && !isBusy) {
        currentProgress = progressFromOffset(y - range.top);
        settledIndex = Math.round(currentProgress);
        render(currentProgress);
        scheduleScrollEndSnap();
      } else if (!withinRange) {
        isActive = false;
        clearScrollEndTimer();
      }
    }

    function onResize() {
      var newInnerHeight = window.innerHeight;

      if (Math.abs(newInnerHeight - lastInnerHeight) < RESIZE_IGNORE_THRESHOLD_PX) {
        return;
      }

      lastInnerHeight = newInnerHeight;
      applySizing();
      measureHeights();
      updateRange();
      onScroll();
    }

    applySizing();
    measureHeights();
    updateRange();
    onScroll();
    render(currentProgress);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: false });
    window.addEventListener('touchend', onTouchEnd, { passive: true });
    requestAnimationFrame(loop);

    window.addEventListener('load', function () {
      measureHeights();
      updateRange();
    });

    window.setTimeout(function () {
      measureHeights();
      updateRange();
    }, 300);

    if (typeof ResizeObserver === 'function') {
      var resizeObserver = new ResizeObserver(function () {
        measureHeights();
      });

      sections.forEach(function (section) {
        resizeObserver.observe(section);
      });
    }
  }

  function init() {
    var sections = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    if (!sections.length) {
      return;
    }

    var inThemeEditor = window.Shopify && window.Shopify.designMode;

    if (!inThemeEditor) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }

    injectStyles();

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || inThemeEditor || sections.length < 2) {
      initFadeOnly(sections);
      return;
    }

    initPinned(sections);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();